import rawManifest from "./illustrations.json";
import type { FigureImage, PartId } from "./types";

export type IllustrationLanguage = "en" | "uk" | "ru";

interface LocalizedIllustrationEntry {
  file: string;
  alt: Record<IllustrationLanguage, string>;
  caption: Record<IllustrationLanguage, string>;
}

interface IllustrationManifest {
  basePath: string;
  width: number;
  height: number;
  home: LocalizedIllustrationEntry;
  parts: Record<PartId, LocalizedIllustrationEntry>;
  essays: Record<string, LocalizedIllustrationEntry>;
  chapterParts: Record<string, PartId>;
}

export const illustrationManifest = rawManifest as IllustrationManifest;

function localizeIllustration(entry: LocalizedIllustrationEntry, language: IllustrationLanguage): Required<FigureImage> {
  return {
    src: `${illustrationManifest.basePath}/${entry.file}`,
    alt: entry.alt[language],
    caption: entry.caption[language],
    width: illustrationManifest.width,
    height: illustrationManifest.height,
  };
}

export function getHomeIllustration(language: IllustrationLanguage) {
  return localizeIllustration(illustrationManifest.home, language);
}

export function getPartIllustration(part: PartId, language: IllustrationLanguage) {
  return localizeIllustration(illustrationManifest.parts[part], language);
}

export function getEssayIllustration(slug: string, language: IllustrationLanguage) {
  const entry = illustrationManifest.essays[slug];
  return entry ? localizeIllustration(entry, language) : undefined;
}

export function getChapterIllustration(slug: string, language: IllustrationLanguage) {
  const part = illustrationManifest.chapterParts[slug];
  return part ? getPartIllustration(part, language) : undefined;
}
